import { type ColumnType, type Selectable } from 'kysely'
import { z } from 'zod'

import { cableId, type CableId } from './Cable.js'
import { cableHistoryId, type CableHistoryId } from './CableHistory.js'
import {
  deviceInventoryStatusType,
  type default as DeviceInventoryStatusType,
} from './DeviceInventoryStatusType.js'
import { organizationId, type OrganizationId } from './Organization.js'
import { projectId, type ProjectId } from './Project.js'

/** Represents the view public.cable_current_history_view_ */
export default interface CableCurrentHistoryViewTable {
  /** Database type: pg_catalog.uuid */
  historyId: ColumnType<CableHistoryId, never, never>

  /** Database type: pg_catalog.int4 */
  cableId: ColumnType<CableId, never, never>

  /** Database type: pg_catalog.timestamptz */
  startedAt: ColumnType<Date | null, never, never>

  /** Database type: pg_catalog.timestamptz */
  endedAt: ColumnType<Date | null, never, never>

  /** Database type: public.device_inventory_status_type_ */
  inventoryStatus: ColumnType<DeviceInventoryStatusType | null, never, never>

  /** Database type: pg_catalog.int4 */
  organizationId: ColumnType<OrganizationId, never, never>

  /** Database type: pg_catalog.text */
  organizationName: ColumnType<string, never, never>

  /** Database type: pg_catalog.timestamptz */
  organizationDeletedAt: ColumnType<Date | null, never, never>

  /** Database type: pg_catalog.int4 */
  projectId: ColumnType<ProjectId | null, never, never>

  /** Database type: pg_catalog.text */
  projectName: ColumnType<string, never, never>

  /** Database type: pg_catalog.timestamptz */
  projectDeletedAt: ColumnType<Date | null, never, never>

  /** Database type: pg_catalog.text */
  createdByUser: ColumnType<string, never, never>

  /** Database type: pg_catalog.text */
  updatedByUser: ColumnType<string, never, never>

  /** Database type: pg_catalog.text */
  deletedByUser: ColumnType<string, never, never>
}

export type CableCurrentHistoryView = Selectable<CableCurrentHistoryViewTable>

export const cableCurrentHistoryView = z.object({
  historyId: cableHistoryId,
  cableId: cableId,
  startedAt: z.coerce.date().nullable().optional(),
  endedAt: z.coerce.date().nullable().optional(),
  inventoryStatus: deviceInventoryStatusType.nullable().optional(),
  organizationId: organizationId,
  organizationName: z.string(),
  organizationDeletedAt: z.coerce.date().nullable().optional(),
  projectId: projectId.nullable().optional(),
  projectName: z.string(),
  projectDeletedAt: z.coerce.date().nullable().optional(),
  createdByUser: z.string(),
  updatedByUser: z.string(),
  deletedByUser: z.string(),
}) as unknown as z.Schema<CableCurrentHistoryView>
